import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {gql, useLazyQuery} from "@apollo/client/index";
import Alert from "@material-ui/lab/Alert/Alert";
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import Button from "@material-ui/core/Button/Button";
import Grid from "@material-ui/core/Grid/Grid";
import LinearProgress from "@material-ui/core/LinearProgress/LinearProgress";

const useStyles = makeStyles((theme) => ({
    root: {

    },
    progress: {
        marginTop: -4
    },
    handle: {
        borderTop: '1px dashed #ccc'
    },
    section: {
        width: '100%'
    },
    button: {
        marginTop: 5
    },
    fullWidth: {
        width: '100%'
    }
}));

const MAKE_ANOTHER_OFFER = gql`
  query($requestCode: String, $updateHash: String, $amountMinorUnits: Int) {
    makeAnotherOffer(requestCode: $requestCode, updateHash: $updateHash, amountMinorUnits: $amountMinorUnits) {
        message
    }
  }
`;

export default function MakeAnotherOfferAction(props) {

    const classes = useStyles();

    let [makeAnotherOffer, {loading, data, error}]
        = useLazyQuery(MAKE_ANOTHER_OFFER);

    const [value, setValue] = React.useState();
    const [offerSent, setOfferSent] = React.useState();


    const handleChange = (event) => {
        setValue(event.target.value);
    };

    const handleMakeAnOffer = () => {
        console.log('data');
        makeAnotherOffer({variables: {
            requestCode: props.request.code,
            updateHash: props.request.updateHash,
            amountMinorUnits: Math.max(0, props.request.bookPriceMinorUnits - value)
        }});
    };


    if (!loading && data) {
        data = null;
        props.onActionComplete();
    }

    const offers = [
        props.request.bookPriceMinorUnits,
        props.request.bookPriceMinorUnits - 100*100,
        props.request.bookPriceMinorUnits - 250*100,
        props.request.bookPriceMinorUnits - 500*100
    ];

    return (
        <div className={classes.root}>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography className={classes.heading}>Make Another Offer</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.handle}>
                    <Grid className={classes.fullWidth}>
                        {offerSent ? <Grid item><Alert className={classes.fullWidth} severity={"success"}>Offer is sent to Dealer</Alert><p></p></Grid> : ''}

                        {error ? <Grid item><Alert className={classes.fullWidth} severity={"error"}>{error.message}</Alert><p></p></Grid> : ''}

                        <Grid item>
                    <div className={classes.section}>
                        <FormControl component="fieldset">
                            <FormLabel component="legend">Please select</FormLabel>
                            <RadioGroup aria-label="offer" name="offer" value={value}
                                        onChange={handleChange}>
                                {offers.map(offer => {
                                    const youSave = Math.max(0, props.request.bookPriceMinorUnits - offer);
                                    return offer !== props.request.anotherOfferAmountMinorUnits ?
                                        <FormControlLabel
                                            disabled={loading} value={offer.toString()}
                                            control={<Radio />}
                                                          label={"$"+new Intl.NumberFormat().format(offer / 100)+
                                                          (youSave > 0 ? " (You save $"+
                                                              + new Intl.NumberFormat().format(youSave / 100)+")" : "")} />
                                        : null;
                                })}
                            </RadioGroup>
                        </FormControl>
                    </div>
                        </Grid>
                        {loading ? <Grid item><LinearProgress className={classes.fullWidth} /></Grid> : ''}
                        <Grid item>
                            <div className={classes.button}>
                                <Button
                                    size="small"
                                    variant="contained"
                                    color="primary"
                                    className={classes.button}
                                    onClick={handleMakeAnOffer}
                                    disabled={loading}
                                >
                                    Make An Offer
                                </Button>
                            </div>
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </div>
    );
}